import { render, staticRenderFns } from "./solicitacao-cirurgia.vue?vue&type=template&id=79d7c465&scoped=true"
import script from "./solicitacao-cirurgia.vue?vue&type=script&lang=ts"
export * from "./solicitacao-cirurgia.vue?vue&type=script&lang=ts"
import style0 from "./solicitacao-cirurgia.vue?vue&type=style&index=0&id=79d7c465&prod&lang=scss"
import style1 from "./solicitacao-cirurgia.vue?vue&type=style&index=1&id=79d7c465&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d7c465",
  null
  
)

export default component.exports